import * as _ from 'lodash';

import { Action, State, StateDetailState } from '../store';

export const actionTypes = {
    FETCH_STATE_REQUEST: 'states/FETCH_STATE_REQUEST',
    FETCH_STATE_SUCCESS: 'states/FETCH_STATE_SUCCESS',
    FETCH_STATE_FAILED: 'states/FETCH_STATE_FAILED',
};

export namespace actions {
    export function fetchStateRequest(name: string) {
        return {
            type: actionTypes.FETCH_STATE_REQUEST,
            payload: name,
        };
    }

    export function fetchStateSuccess(w: State) {
        return {
            type: actionTypes.FETCH_STATE_SUCCESS,
            payload: w,
        };
    }

    export function fetchStateFailed(error: string) {
        return {
            type: actionTypes.FETCH_STATE_FAILED,
            payload: { error },
        };
    }
}

export namespace reducers {

    type NewState = State & { id: number };
    type StatesAction = Action<{} | State[] | NewState | { error: string }>;
    type StateAction = Action<State>;
    export function stateDetailReducer(
        state: StateDetailState = { status: 'none' },
        action: StateAction) {
        if (stateDetailHandler[action.type]) {
            return stateDetailHandler[action.type](state, action);
        }
        return state;
    }

    const stateDetailHandler: {
        [id: string]:
        (state: StateDetailState, action: StatesAction) => StateDetailState
    } = {

        [actionTypes.FETCH_STATE_REQUEST]: (state, action) => {
            return _.assign({}, state, {
                status: 'loading'
            });
        },
        [actionTypes.FETCH_STATE_SUCCESS]: (state, action) => {
            return _.assign({}, state, {
                status: 'loaded',
                data: action.payload,
            });
        },
        [actionTypes.FETCH_STATE_FAILED]: (state, action) => {
            return _.assign({}, state, {
                status: 'error',
                error: (action.payload as any).error, // tslint:disable-line
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/states/redux.ts